import * as colors from "./colors";

export default {
	interactive: colors.lightPurple,
	video: colors.teal4,
	live: colors.lightOrange2,
	recorded: colors.lightGreen,
	textShadow: "rgba(12, 53, 45, 0.94)",
};



// WEBPACK FOOTER //
// ./src/constants/typeColors.js